for (const el of document.querySelectorAll('.vp-block-media-text-full')) {
    el.querySelector('.toggle-fullwidth')?.addEventListener('click', (e) => {
        el.classList.toggle('has-media-open')
    })
}
